import { TaskTimeline } from '@euler/app/flows/task/components/TaskTimeline';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { Aside } from '@euler/components/Aside';
import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { adaptiveWrapperOptions } from '@euler/functions/navigationOptionsBuilder';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  isMobileLayout,
  useIsMobileLayout,
} from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const TaskTimelineScreen = wrapNavigatorScreen(
  ({ readonly }: { readonly?: boolean }) => {
    const insets = useSafeAreaInsets();
    const { rpx } = useResponsiveContext();
    const { taskNo, profile } = useTaskContext();
    const isMobile = useIsMobileLayout();

    if (isMobile) {
      return (
        <LayoutProviderView
          css={`
            flex: 1;
            background-color: #fff;
            margin: ${rpx(10)}px;
            border-radius: ${rpx(5)}px;
            padding: ${rpx(15)}px 0;
            margin-bottom: ${insets.bottom + rpx(10)}px;
          `}
        >
          <TaskTimeline
            taskNo={taskNo}
            readonly={readonly}
            isIndependentDeliveryCheckEnabled={
              profile.store.isIndependentDeliveryCheckEnabled
            }
          />
        </LayoutProviderView>
      );
    }

    return (
      <Aside dismissible>
        <LayoutProviderView
          css={`
            flex: 1;
            background-color: #fff;
            margin: ${rpx(10)}px;
            border-radius: ${rpx(5)}px;
            padding: ${rpx(15)}px 0 ${rpx(15)}px 0;
            margin-bottom: ${insets.bottom + rpx(10)}px;
          `}
        >
          <TaskTimeline
            taskNo={taskNo}
            isIndependentDeliveryCheckEnabled={
              profile.store.isIndependentDeliveryCheckEnabled
            }
          />
        </LayoutProviderView>
      </Aside>
    );
  },
  adaptiveWrapperOptions<any>(() => ({
    title: '进度详情',
    headerStatusBarHeight: undefined,
    headerShown: isMobileLayout(),
  })),
);
